module.exports = __webpack_public_path__ + "static/img/01.953a2a80.jpeg";